/**
 * TS mirror of casper.trigger_enums.parse_allowed_values.
 * Extracts options from "Allowed values: X, Y, Z." suffix in descriptions.
 */
export function parseAllowedValues(description: string | null | undefined): string[] | null {
  if (!description) return null;
  const parts = description.split("Allowed values");
  let blob: string;
  if (parts.length > 1) {
    // take the LAST occurrence
    blob = parts[parts.length - 1].replace(/^[:\s]+/, "").replace(/[\s.]+$/, "");
  } else {
    const m = description.match(/allowed\s+values\s*:\s*(.+?)\s*\.?\s*$/is);
    if (!m) return null;
    blob = m[1];
  }
  const options = blob.split(",").map(o => o.trim()).filter(Boolean);
  return options.length > 0 ? options : null;
}
